import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ index, label }) => (
  <div className="mb-6 flex items-center gap-4" aria-hidden="true">
    <span className="font-display text-sm font-bold tracking-[0.25em] text-[#00D4FF]">{index}</span>
    <span className="h-px w-12 bg-gradient-to-r from-[#00D4FF]/70 to-transparent" />
    <span className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">{label}</span>
  </div>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <ChapterTag index={eyebrow.index} label={eyebrow.label} />
    <h2 className="font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
      {title}
    </h2>
    {sub && (
      <p className={`mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg ${align === "center" ? "mx-auto" : ""}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
